"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactLazyComponent = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const ModuleRegistry_1 = require("./ModuleRegistry");
const ReactModuleContainerErrors_1 = require("./ReactModuleContainerErrors");
const tag_appender_1 = require("./tag-appender");
class ReactLazyComponent extends react_1.Component {
    constructor(props, manifest) {
        super(props, manifest);
        this.manifest = manifest;
        this.state = { component: null };
        this.manifest = manifest;
    }
    UNSAFE_componentWillMount() {
        (0, ModuleRegistry_1.getModuleRegistry)().notifyListeners('reactModuleContainer.componentStartLoading', this.manifest.component);
        const prepare = this.manifest.prepare ? () => this.manifest.prepare() : () => undefined;
        const filesAppenderPromise = (0, tag_appender_1.filesAppender)(this.manifest.files, this.manifest.crossorigin).then(prepare);
        const resolvePromise = this.manifest.resolve ? this.manifest.resolve() : Promise.resolve({});
        this.resourceLoader = Promise.all([resolvePromise, filesAppenderPromise])
            .then(([resolvedData]) => {
            this.resolvedData = resolvedData;
            (0, ModuleRegistry_1.getModuleRegistry)().notifyListeners('reactModuleContainer.componentReady', this.manifest.component);
        })
            .catch((err) => {
            (0, ModuleRegistry_1.getModuleRegistry)().notifyListeners('reactModuleContainer.error', new ReactModuleContainerErrors_1.LazyComponentLoadingError(this.manifest.component, err));
        });
    }
    componentDidMount() {
        this.resourceLoader.then(() => {
            const component = (0, ModuleRegistry_1.getModuleRegistry)().component(this.manifest.component);
            this.setState({ component });
        });
    }
    componentWillUnmount() {
        if (this.manifest.unloadStylesOnDestroy !== false) {
            (0, tag_appender_1.unloadStyles)(document, this.manifest.files);
        }
        (0, ModuleRegistry_1.getModuleRegistry)().notifyListeners('reactModuleContainer.componentWillUnmount', this.manifest.component);
    }
    render() {
        const RenderedComponent = this.state.component;
        if (!RenderedComponent) {
            return null;
        }
        return react_1.default.createElement(RenderedComponent, Object.assign({}, this.props, this.resolvedData));
    }
}
exports.ReactLazyComponent = ReactLazyComponent;
//# sourceMappingURL=ReactLazyComponent.js.map